export default {
  zh: {
    title: '升级Lead为Account',
    platform: '交易平台设置',
    portal: '客户入口设置',
    type: 'Opportunity类型',
    accountNum: '客户交易账号',
    password: '密码',
    loginAccount: '入口账号',
    portalPassword: '密码',
  },
  en: {
    title: 'Convert Lead',
    platform: 'Trading Platform',
    portal: 'Client Portal',
    type: 'Opportunity Type',
    accountNum: 'Trading Account Number',
    password: 'Password',
    loginAccount: 'Portal Login',
    portalPassword: 'Password',
  },
};



// WEBPACK FOOTER //
// ./src/views/ConvertLeads/i18n.js